import React from 'react';
import FaIcon from '../../../Elements/FaIcon';
import FieldTypesEnum from '../../../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../../../Enums/TabListTableCellWidthEnum';
import JsxHelper from '../../../Helpers/JsxHelper';
import GeneralEntryLogFigma from '../../../Elements/GeneralEntryLog/GeneralEntryLogFigma';
import CommentsEntryLogDescription from '../../../Elements/CommentsEntryLogDescription';
import LogComponent from '../../../Elements/LogComponent';
import FigmaBadge from '../../../Elements/FigmaBadge';
import DataTableActionMenu from '../../../Elements/DataTable/DataTableActionMenu';
import InferiorUsers from '../../../Elements/InferiorUsers';
import urlHelper from '../../../Helpers/urlHelper';
import CommissionRatesAdmin from '../CommissionRate/CommissionRatesAdmin';
import LongText from '../../../Elements/LongText';
import ThirdPartySystemsAdmin from '../ThirdPartySystemsAdmin';
import OutsourcedUserFteAdmin from './OutsourcedUserFteAdmin';

export default class UserItem {
  constructor(item) {
    if (item === undefined) {
      this.UserId = '';
      this.OfficeId = '';
      this.UserName = '';
      this.FirstName = '';
      this.LastName = '';
      this.Email = '';
      this.IsActive = '';
      this.OfficialJobTitleId = '';
      this.Roles = '';
      this.TimesheetUser = '';
      this.OfficeName = '';
      this.OfficialJobTitle = '';
      this.RelatedUsers = [];
      this.TimesheetUserUserName = '';
      this.Department = '';
      this.SuperVisorName = '';
      this.SupervisorId = '';
      this.SubstitutedById = '';
      this.DepartmentId = '';
      this.ApolloMgrId = '';
      this.TierPos = '';
      this.NotificationsEnabled = '';
      this.IsOutsourcedEmployee = false;
      this.PosnumberId = '';
      this.WorkforceType = '';
      this.SubstitutedByName = '';
      this.TimeZoneOffset = '';
      this.TimeZoneOffsetName = '';
      this.GroupIds = [];
      this.Selected = false;
      this.GuidId = '';
      this.IncludeSecondaryAccountsInCostCalculation = false;
      this.IncludeVendorCostInCostCalculation = false;
      return;
    }
    this.UserId = item.userId;
    this.OfficeId = item.officeId;
    this.UserName = item.userName;
    this.FirstName = item.firstName;
    this.LastName = item.lastName;
    this.Email = item.email;
    this.IsActive = item.isActive;
    this.OfficialJobTitleId = item.officialJobTitleId;
    this.Roles = item.roles;
    this.TimesheetUser = item.timesheetUser;
    this.OfficeName = item.officeName;
    this.OfficialJobTitle = item.officialJobTitle;
    this.RelatedUsers = item.relatedUsers;
    this.TimesheetUserUserName = item.timesheetUserUserName;
    this.Department = item.department;
    this.SuperVisorName = item.superVisorName;
    this.SupervisorId = item.supervisorId;
    this.SubstitutedById = item.substitutedById;
    this.DepartmentId = item.departmentId;
    this.ApolloMgrId = item.apolloMgrId;
    this.TierPos = item.tierPos;
    this.NotificationsEnabled = item.notificationsEnabled;
    this.IsOutsourcedEmployee = item.isOutsourcedEmployee;
    this.PosnumberId = item.posnumberId;
    this.NoTs = item.noTs;
    this.WorkforceType = item.workforceType;
    this.SubstitutedByName = item.substitutedByName;
    this.TimeZoneOffset = item.timeZoneOffset;
    this.TimeZoneOffsetName = item.timeZoneOffsetName;
    this.GroupIds = item.groupIds;
    this.Selected = false;
    this.GuidId = item.guidId;
    // === true coalesces a missing or NULL value to false, which would otherwise render as a valid-looking
    // Off toggle that fails the required-bool validation and blocks saving. The secondary-accounts column is
    // NOT NULL on both databases now, so there it only guards against an older API payload; the vendor-cost
    // column is still nullable and the Azure user sync can write NULLs into it.
    this.IncludeSecondaryAccountsInCostCalculation = item.includeSecondaryAccountsInCostCalculation === true;
    this.IncludeVendorCostInCostCalculation = item.includeVendorCostInCostCalculation === true;
  }

  static NameOfTheIdField() {
    return 'UserId';
  }

  static nameOfTheItemDetailList(item) {
    return (
      <LongText
        text={`User - ${item.FirstName}, ${item.LastName} (${item.UserId})`}
        fitToBox
      />
    );
  }

  static MoneyFields = [];

  static Currency() {
    return 'USD';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return 'USD';
  }

  static DateFields = [];

  static BoolFields = [
    'IsActive',
    'NotificationsEnabled',
    'NoTs',
    'IsOutsourcedEmployee',
    'IncludeSecondaryAccountsInCostCalculation',
  ];

  static editFunction = (id, user, userList) => {
    alert('Empty Function');
  };

  static ObjectArrayFields = [
    {
      name: 'RelatedUsers',
      label: 'User',
      fieldsToShow: [
        { name: 'userId', label: 'UserId' },
        { name: 'userName', label: 'UserName' },
        { name: (item) => JsxHelper.YesNo(item.isActive), label: 'Is Active?', className: 'text-center' },
        { name: 'officeName', label: 'OfficeName' },
        {
          name: (item) => JsxHelper.YesNo(item.isTimesheetUser),
          label: 'Is Timesheet User?',
          width: TabListTableCellWidthEnum.Single,
          className: 'text-center',
        },
        {
          label: (item, mainItem) => UserItem.generateRelatedUserEditLink(item, mainItem),
          width: TabListTableCellWidthEnum.Single,
          rolekey: 'useradmin_EditUser',
        },
        { name: 'roles', label: 'Roles', width: TabListTableCellWidthEnum.Full },
      ],
    },
  ];

  static FieldsToShowInListTable = [
    {
      tabName: 'Users',
      tabLabel: 'Users',
      icon: 'fa-solid fa-user',
      data: [
        { name: 'RelatedUsers', label: 'Related Users' },
        { name: '', label: '', width: TabListTableCellWidthEnum.Full },
        {
          name: UserItem.generateAddNewRelatedUserLink,
          label: '',
          rolekey: 'useradmin_EditUser',
          width: TabListTableCellWidthEnum.TwoLines,
        },
      ],
    },
    {
      tabName: 'Organization',
      tabLabel: 'Organization',
      icon: 'fa-solid fa-sitemap',
      data: [
        { name: 'OfficeName', label: 'Primary Office' },
        { name: (item) => JsxHelper.YesNo(item.IsActive), label: 'Is Active?', className: 'text-center' },
        { name: UserItem.getOfficialJobTitleFieldContent, label: 'Official Job Title' },
        { name: 'Department', label: 'Department' },
        { name: UserItem.getSupervisorCellContent, label: 'Supervisor' },
        { name: 'ApolloMgrId', label: 'Apollo Manager Id' },
        { name: 'TierPos', label: 'Tier POS' },
        { name: 'NotificationsEnabled', label: 'Ts Notifications Enabled' },
        { name: 'NoTs', label: 'Excluded from Timesheet report' },
        { name: 'WorkforceType', label: 'Workforce type' },
        { name: 'SubstitutedByName', label: 'Back-up' },
        {
          name: (item) => JsxHelper.YesNo(item.IsOutsourcedEmployee),
          label: 'Is Outsourced Employee',
          className: 'text-center',
        },
        {
          name: (item) => JsxHelper.YesNo(item.IncludeSecondaryAccountsInCostCalculation),
          label: 'Include Secondary Accounts In Cost Calculation?',
          className: 'text-center',
        },
        {
          // CD-5220: only contractors can carry this, so show a dash for everyone else rather than a
          // misleading "No".
          name: (item) =>
            item.WorkforceType === 'Contractor' ? JsxHelper.YesNo(item.IncludeVendorCostInCostCalculation) : '-',
          label: 'Include Vendor Cost In Cost Calculation?',
          className: 'text-center',
        },
        { name: UserItem.getInferiorsCellContent, label: 'Direct reports', width: TabListTableCellWidthEnum.TwoLines },
        { name: '-message-', label: 'The data above are related to the primary user.' },
      ],
    },
    {
      tabName: 'CommissionRates',
      tabLabel: 'Commission Rates',
      icon: 'fa-solid fa-magnifying-glass-chart fa-2x',
      data: [
        {
          name: (item) => (
            <CommissionRatesAdmin
              userId={item.UserId}
              officeId={item.OfficeId}
            />
          ),
          label: 'Ignored Surveys',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'OutsourcedUserFTE',
      tabLabel: 'Outsourced FTE',
      icon: 'fa-solid fa-people-arrows fa-2x',
      rolekey: 'outsourcedfte_usertab',
      hidden: (item) => !item.IsOutsourcedEmployee,
      data: [
        {
          name: (item) => (
            <OutsourcedUserFteAdmin
              userId={item.UserId}
              officeId={item.OfficeId}
            />
          ),
          label: 'Outsourced FTE',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Third-Party Systems',
      tabLabel: 'Third-Party Systems',
      icon: 'fa-brands fa-grav fa-2x',
      data: [
        {
          name: UserItem.getThirdPartySystemsContent,
          label: 'Third-Party Systems',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-solid fa-comment',
      rolekey: 'useradmin_comments',
      data: [
        { name: UserItem.getCommentsContent, label: 'Comments', width: TabListTableCellWidthEnum.TwoLines },
        { name: '-message-', label: 'The comments above are related to the primary user.' },
      ],
    },
    {
      tabName: 'Log',
      tabLabel: 'Log',
      icon: 'fa-solid fa-stream',
      data: [{ name: UserItem.getLogContent, label: 'Log', width: TabListTableCellWidthEnum.TwoLines }],
    },
  ];

  static getLogContent(item) {
    return (
      <LogComponent
        entityType='User'
        entityId={item.UserId}
      />
    );
  }

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show
  //   if type is FieldTypesEnum.FunctionField then it is the function
  //   In the following example the FreelancerUserItem.editFunction function is a static variable in this class, so you can change its value
  //   I change the value in the constructor of the FreelancerUserAdmin component
  static FieldsToShowInDataTable() {
    return [
      {
        label: UserItem.getSelectedCellHeader,
        orderById: '',
        data: UserItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        rolekey: 'useradmin_EditUser',
        minWidth: 2,
        className: 'text-center',
      },
      { label: 'UserId', orderById: 'UserId', data: 'UserId', type: FieldTypesEnum.DataFieldWithDetails, minWidth: 20 },
      {
        label: 'Name',
        orderById: 'LastName',
        data: (item) => `${item.FirstName} ${item.LastName}`,
        type: FieldTypesEnum.PureDataField,
      },
      { label: 'Primary Office', orderById: 'OfficeId', data: 'OfficeName', type: FieldTypesEnum.PureDataField },
      {
        label: 'Department',
        orderById: 'Department',
        data: (item) => item.Department.replaceAll(' ', '\u00a0'),
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Official Job Title',
        orderById: 'OfficialJobTitleId',
        data: (item) => (
          <LongText
            text={item.OfficialJobTitle}
            maxLength={30}
          />
        ),
        type: FieldTypesEnum.PureDataField,
      },
      {
        label: 'Email',
        orderById: 'Email',
        data: (item) => JsxHelper.MailTo(item.Email),
        type: FieldTypesEnum.PureDataField,
      },
      { label: 'Primary UserName', orderById: 'UserName', data: 'UserName', type: FieldTypesEnum.PureDataField },
      {
        label: 'Users',
        orderById: '',
        data: (item) => JsxHelper.LeftDiv(item.RelatedUsers.length),
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'IsActive',
        orderById: 'IsActive',
        data: (item) => UserItem.getIsActiveCellContent(item.IsActive),
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'TimesheetUser',
        orderById: 'TimesheetUserUserName',
        data: UserItem.generateTimesheetUserLink,
        type: FieldTypesEnum.PureDataField,
        rolekey: 'useradmin_EditUser',
      },
      { label: ' ', orderById: '', data: UserItem.getEditUserFieldContent, type: FieldTypesEnum.ActionButton },
    ];
  }

  static clickOnGlobalSelect(item, selected) {}

  static getSelectedCellHeader() {
    return (
      <input
        type='checkbox'
        checked={UserItem.selectedStatus()}
        onChange={(e) => {
          UserItem.clickOnGlobalSelect(e.target.checked);
        }}
      />
    );
  }

  static selectedStatus() {
    return false;
  }

  static getIsActiveCellContent(item) {
    return (
      <div className='pointer'>
        {
          <FigmaBadge
            Active={item}
            ActiveText='Yes'
            InactiveText='No'
            width={50}
          />
        }
      </div>
    );
  }

  static getEditUserFieldContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            onClick: () => UserItem.editFunction(item.UserId, item),
            text: 'Edit',
            roleKey: 'useradmin_EditUser',
            tooltipText: 'Edit user',
          },
          {
            iconName: 'fa-solid fa-calendar-circle-plus',
            onClick: () => UserItem.grantTimesheetExtendedEditPermission(item),
            text: 'Ext. TS Permission',
            roleKey: 'useradmin_enable_user_past_timesheetentries',
            tooltipText: 'Extend timesheet permission for entries more than 3 days in the past',
          },
        ]}
      />
    );
  }

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            UserItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }
  static clickOnSelect(item, selected) {
    alert('Click');
  }

  static generateAddNewRelatedUserLink(item) {
    return (
      <div
        className='m-0 p-0'
        onClick={() => UserItem.clickOnAddNewRelatedUserLink(item)}
      >
        <span className='link'>
          <FaIcon iconName='fa-solid fa-plus-circle' /> Add New Related User
        </span>
      </div>
    );
  }

  static getInferiorsCellContent(item) {
    return <InferiorUsers supervisorId={item.UserId} />;
  }

  static getThirdPartySystemsContent(item) {
    return <ThirdPartySystemsAdmin UserId={item.UserId} />;
  }

  static getSupervisorCellContent(item) {
    return (
      <span>
        {urlHelper.getLinkComponent(
          `${item.SuperVisorName} (${item.SupervisorId})`,
          'home_users/search',
          `Id=${item.SupervisorId}`
        )}
      </span>
    );
  }

  static getGrantTimesheetExtendedEditPermissionCellContent(item) {
    return (
      <div
        className='m-0 p-0'
        onClick={() => UserItem.grantTimesheetExtendedEditPermission(item)}
      >
        <span className='link'>
          <FaIcon iconName='fa-solid fa-plus-circle' /> Grant Extended Timesheet Edit Permission for three days
        </span>
      </div>
    );
  }

  static clickOnAddNewRelatedUserLink(item) {}

  static grantTimesheetExtendedEditPermission(item) {}

  static getCommentsContent(item) {
    return (
      <GeneralEntryLogFigma
        description={CommentsEntryLogDescription}
        context={{ entityTypeId: 1, entityId: item.UserId }}
      />
    );
  }

  static getOfficialJobTitleFieldContent(item) {
    let imgsrc = '';
    if (item.OfficialJobTitle?.includes('Software Developer'))
      imgsrc = 'https://i.kym-cdn.com/entries/icons/facebook/000/039/184/neocover.jpg';
    else if (item.OfficialJobTitle === 'IT Business Relationship Manager')
      imgsrc =
        'https://cdn-img.scalabs.com.au/1iLG7-F3krQ5vZISJ4kXW-mlSiS93KTZwHeDXRut4e0/aHR0cHM6Ly9zdy10/cmlwbGVtLXByZC5z/Y2FkaWdpdGFsLmlv/L21lZGlhLzQ2ODg3/L21pbmktbWUuanBn/P3ByZXNldD1NYWlu/SW1hZ2U';

    if (imgsrc !== '') {
      return (
        <div className='text-center'>
          <div>
            <img
              src={imgsrc}
              style={{ maxWidth: '200px', maxHeight: '200px' }}
              alt='jobImg'
            />
          </div>
          <div>{item.OfficialJobTitle}</div>
        </div>
      );
    }
    return item.OfficialJobTitle;
  }

  static generateTimesheetUserLink(item) {
    const userNumber = item.RelatedUsers.length;
    const clickable = userNumber > 1 || item.TimesheetUserUserName === '';
    return (
      <div
        className={`text-center m-0 p-0${clickable ? ' secondarylink ' : ''}`}
        onClick={clickable ? () => UserItem.clickOnTimesheetUserItemLink(item) : null}
      >
        {clickable ? (
          <>
            <FaIcon iconName='fa-solid fa-clock' />{' '}
          </>
        ) : (
          ''
        )}
        {item.TimesheetUserUserName ? item.TimesheetUserUserName : '-'}
      </div>
    );
  }

  static generateRelatedUserEditLink(subItem, mainItem) {
    return (
      <div
        className='link'
        onClick={() => UserItem.clickOnEditRelatedUserLink(subItem, mainItem)}
      >
        <FaIcon iconName='fa-solid fa-edit' /> Edit User ({subItem.userName})
      </div>
    );
  }

  static clickOnEditRelatedUserLink(subItem, mainItem) {
    alert('Empty function');
  }

  static clickOnTimesheetUserItemLink(item) {
    alert('Empty function');
  }

  static CreateEditedUserJSONObject(editedUser) {
    const userJSON = {
      EvaluatorId: editedUser.EvId.toString(),
      EvPaymentMethod: editedUser.EvPaymentMethod,
      EvVatType: editedUser.EvVatType,
      TransactionMethod: editedUser.EvTransactionMethod ? editedUser.EvTransactionMethod : '',
      EvIsAgency: editedUser.EvIsAgency.toString(),
    };
    return JSON.stringify(userJSON);
  }
}
